<template>
  <div class="pa-0 ma-0">
    <LoginForm mode="update" :response="message" v-on:form-submitted="changePassword">
    </LoginForm>
    <v-dialog v-model="dialog" persistent max-width="480">
      <v-card>
        <v-card-title class="headline">Password Changed</v-card-title>
        <v-card-text>Your password has been successfully changed.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text to="/labs">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LoginForm from '@/components/LoginForm.vue';

export default {
  name: 'ChangePassword',
  components: { LoginForm },
  data: () => ({
    dialog: false,
    message: {
      content: '',
      color: 'black',
    },
  }),
  computed: {
    modeTitle() {
      return this.modeOptions[this.mode] || '';
    },
  },
  methods: {
    changePassword(data) {
      const url = 'https://portal.beyondlabz.com/auth/update';
      this.$http.post(url, data)
        .then((resp) => {
          console.log('ChangePassword :: changePassword :: ', resp);
          if (resp.status === 200) {
            if (resp.data.updated) {
              this.dialog = true;
            } else {
              this.message.content = 'Failed to change password. Please try again or contact support@beyondlabz.com.';
              this.message.color = 'red';
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.message.content = 'Failed to change password. Please try again or contact support@beyondlabz.com.';
          this.message.color = 'red';
        });
    },
  },
};
</script>

<style scoped>

</style>
